import React from 'react';

// A KPI card: eyebrow label, large display number (optionally tabular mono),
// optional trend line in success-green or muted.

interface Props {
  label: string;
  value: string;
  mono?: boolean;
  trend?: string;
  tone?: 'success' | 'muted';
}

const KpiTile = ({ label, value, mono, trend, tone = 'muted' }: Props) => (
  <div className="card">
    <div className="eyebrow">{label}</div>
    <div className={`kpi-num ${mono ? 'mono' : ''}`} style={{ marginTop: 14 }}>
      {value}
    </div>
    {trend && (
      <div
        style={{
          marginTop: 10,
          fontSize: 12,
          color: tone === 'success' ? 'var(--success)' : 'var(--ink-3)'
        }}
      >
        {tone === 'success' && '▲ '}
        {trend}
      </div>
    )}
  </div>
);

export default KpiTile;
